<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="searchForm" :model="staffReq" label-width="70px" inline size="small">
					<el-form-item label="员工昵称:">
						<el-input :clearable="true" v-model="staffReq.nickName" placeholder="请输入员工昵称" style="width: 150px;" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getStaffList()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button @click="resetQuery()">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 员工列表区 -->
			<el-table :data="staffList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index"></el-table-column>
				<el-table-column label="员工昵称" prop="nickName"></el-table-column>
				<el-table-column label="手机号" prop="mobile"></el-table-column>
				<el-table-column label="运营商" prop="distributorId">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" @change="staffStateChanged(scope.row)" active-color="#3CA757"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="审批状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.approval === 'Y' ? 'success' : 'warning'">
							{{ scope.row.approval === 'Y' ? '已通过' : '待审批' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="remark"></el-table-column>
				<el-table-column label="创建时间" prop="createTime"></el-table-column>
				<el-table-column label="操作" width="280px">
					<template slot-scope="scope">
						<!-- 待审批状态：只显示审批按钮 -->
						<template v-if="scope.row.approval !== 'Y'">
							<el-button type="success" icon="el-icon-check" size="mini"
								@click="approveStaff(scope.row)">审批</el-button>
						</template>
						<!-- 已审批状态：显示编辑和角色分配按钮 -->
						<template v-else>
							<el-button type="primary" icon="el-icon-edit" size="mini"
								@click="editStaff(scope.row)">编辑</el-button>
							<el-button type="primary" icon="el-icon-s-grid" size="mini" style="margin-left: 8px;"
								@click="assignRoles(scope.row)">角色分配</el-button>
							<el-button v-if="isAdmin" type="warning" icon="el-icon-connection" size="mini" style="margin-left: 8px;"
								@click="manageDistributors(scope.row)">运营商</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="staffReq.page" :page-sizes="[8, 15, 25, 50, 100]" :page-size="staffReq.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 编辑员工对话框 -->
			<el-dialog title="编辑员工" :visible.sync="editDialogVisible" width="600px">
				<el-form :model="editStaffForm" status-icon ref="editStaffForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="员工昵称" prop="nickName">
						<el-input v-model="editStaffForm.nickName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile">
						<el-input v-model="editStaffForm.mobile" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="运营商" prop="distributorId" v-if="isAdmin">
						<el-select v-model="editStaffForm.distributorId" placeholder="请选择运营商" size="small" filterable
							@change="handleDistributorChange" style="width: 100%;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="editStaffForm.remark" type="textarea" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="editDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateStaff()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 角色分配对话框 -->
		<el-dialog title="员工角色分配" :visible.sync="roleDialogVisible" width="500px">
			<el-form :model="roleForm" label-width="100px">
				<el-form-item>
					<el-radio-group v-model="selectedRole" style="width: 100%;">
						<el-radio v-for="role in roleList" :key="role.id" :label="role.id" style="width: 100%; margin: 10px 0;">
							{{ role.roleName }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="roleDialogVisible = false">取 消</el-button>
				<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="saveRoles()">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 绑定运营商对话框 -->
		<el-dialog title="绑定运营商" :visible.sync="distributorDialogVisible" width="600px">
			<el-table :data="boundDistributors" border size="small" style="margin-bottom: 15px;">
				<el-table-column label="运营商名称" prop="distributorName"></el-table-column>
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-button type="danger" size="mini" @click="unbindDistributor(scope.row)">解绑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-divider></el-divider>
			<el-form :inline="true" size="small">
				<el-form-item label="添加运营商">
					<el-select v-model="addDistributorId" placeholder="请选择运营商" filterable style="width: 300px;">
						<el-option v-for="item in unboundDistributorOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="bindDistributor">添加</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			//是否是超级管理员
			isAdmin: false,
			staffReq: {
			//当前页数
			page: 1,
			//当前每页多少条
			limit: 8,
			nickName: '',
			distributorId: '',
			queryDistributorId: ''
		},
			staffList: [],
			total: 0,
			//控制编辑员工对话框显示与隐藏
			editDialogVisible: false,
			//编辑员工表单
			editStaffForm: {
				id: '',
				nickName: '',
				distributorId: '',
				distributorName: '',
				mobile: '',
				remark: ''
			},
			//运营商列表
			distributorOptions: [],
			//角色分配对话框
			roleDialogVisible: false,
			//当前操作的员工
	currentStaff: {},
		//角色分配表单
	roleForm: {},
			//角色列表数据
	roleList: [],
			selectedRole: '',
			distributorDialogVisible: false,
			boundDistributors: [],
			addDistributorId: '',
			currentDistributorStaff: null
		}
	},
	computed: {
		unboundDistributorOptions() {
			const boundIds = this.boundDistributors.map(item => item.distributorId)
			return this.distributorOptions.filter(item => !boundIds.includes(item.key))
		}
	},
	created() {
		this.staffReq.queryDistributorId = getCurrentDistributorId()
		this.checkIsSuperAdmin()
		this.getStaffList()
		this.getDistributorList()
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.staffReq.queryDistributorId = distributorId || ''
			this.staffReq.page = 1
			this.getStaffList()
		},
		//检查是否是超级管理员
		checkIsSuperAdmin() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		},
		//根据运营商ID获取运营商名称
		getDistributorName(distributorId) {
			if (!distributorId) return '-'
			const distributor = this.distributorOptions.find(item => item.key === distributorId)
			return distributor ? distributor.value : '-'
		},
		async getStaffList() {
			const { data: res } = await this.$http.post(
				'/mini/operationMiniUser/getStaffPageInfo',
				this.staffReq)
				console.log('获取员工列表响应:', res)
			if (res.code != 200) return this.$message.error(res.msg)
			this.staffList = res.data.list
			this.total = res.data.total
		},
		//获取运营商列表
		getDistributorList() {
			this.$http.get('distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
			});
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.staffReq.limit = pageSize
			this.getStaffList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.staffReq.page = pageNum
			this.getStaffList()
		},
		//员工状态变更
		staffStateChanged(staff) {
			this.$http.post('/mini/operationMiniUser/updateStatus', {
				id: staff.id,
				status: staff.status,
			}).then((res) => {
				if (res.data.code == 200) {
						this.$message.success(staff.status ? '已开启' : '已禁用')
					} else {
						this.$message.error('状态更新失败')
						// 恢复原状态
						staff.status = !staff.status
					}
			})
		},
		//编辑员工
		editStaff(staff) {
			this.editStaffForm = {
				id: staff.id,
				nickName: staff.nickName,
				distributorId: staff.distributorId,
				distributorName: staff.distributorName,
				mobile: staff.mobile || '',
				remark: staff.remark
			}
			this.editDialogVisible = true
		},
		//处理运营商选择变化
		handleDistributorChange(distributorId) {
			const selectedDistributor = this.distributorOptions.find(item => item.key === distributorId)
			if (selectedDistributor) {
				this.editStaffForm.distributorName = selectedDistributor.value
			}
		},
		//更新员工
		async updateStaff() {
			const { data: res } = await this.$http.post(
				'/mini/operationMiniUser/updateStaff',
				this.editStaffForm)
			if (res.code != 200) return this.$message.error(res.msg)
			this.$message.success('更新成功')
			this.editDialogVisible = false
			this.getStaffList()
		},
		//删除员工
		deleteStaff(id) {
			this.$confirm("确认删除该员工吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('mini/operationMiniUser/deleteById/' + id).then(res => {
					if (res.data.code == 200) {
						this.getStaffList()
						this.$message.success('删除成功')
					} else {
						this.$message.error('删除失败')
					}
				})
			})
		},
		//角色分配
		async assignRoles(staff) {
			this.currentStaff = staff
			this.roleDialogVisible = true
			// 调用角色列表接口
			const { data: res } = await this.$http.get('/api/permission/role/list')
			if (res.code != 200) return this.$message.error(res.message)
			this.roleList = res.data
			// 调用员工已有角色接口
			const { data: roleRes } = await this.$http.get(`/api/permission/staff-role/${staff.openId}`)
			if (roleRes.code != 200) return this.$message.error(roleRes.message)
			// 初始化选中的角色（取第一个角色）
			const roleIds = roleRes.data.roleIds || []
			this.selectedRole = roleIds.length > 0 ? roleIds[0] : ''
		},

		//保存角色
		async saveRoles() {
			if (!this.selectedRole) {
				return this.$message.warning('请选择角色')
			}
			const { data: res } = await this.$http.post(
				'/api/permission/staff-role',
				{
					openId: this.currentStaff.openId,
					roleIds: [this.selectedRole]
				})
			if (res.code != 200) return this.$message.error(res.message)
			this.$message.success('角色分配成功')
			this.roleDialogVisible = false
		},
		// 审批员工
		async approveStaff(staff) {
			try {
				await this.$confirm('确认审批通过该员工吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				})
				
				const { data: res } = await this.$http.get(`/mini/operationMiniUser/approve/${staff.id}`)
				if (res.code != 200) return this.$message.error(res.msg || '审批失败')
				
				this.$message.success('审批通过')
				this.getStaffList()
			} catch (e) {
				if (e !== 'cancel') {
					this.$message.error('审批失败')
				}
			}
		},
		async manageDistributors(staff) {
			this.currentDistributorStaff = staff
			this.addDistributorId = ''
			this.distributorDialogVisible = true
			await this.loadBoundDistributors(staff.id)
		},
		async loadBoundDistributors(userId) {
			const { data: res } = await this.$http.get(`/mini/operationMiniUser/distributors/${userId}`)
			if (res.code === 200) {
				let distributors = res.data || []
				// 根据distributorId映射运营商名称
				distributors = distributors.map(item => {
					if (!item.distributorName && item.distributorId) {
						const distributor = this.distributorOptions.find(d => d.key === item.distributorId)
						if (distributor) {
							return { ...item, distributorName: distributor.value }
						}
					}
					return item
				})
				this.boundDistributors = distributors
			} else {
				this.boundDistributors = []
			}
		},
		async bindDistributor() {
			if (!this.addDistributorId) {
				return this.$message.warning('请选择运营商')
			}
			const selected = this.distributorOptions.find(item => item.key === this.addDistributorId)
			const { data: res } = await this.$http.post('/mini/operationMiniUser/bindDistributor', {
				userId: this.currentDistributorStaff.id,
				distributorId: this.addDistributorId,
				distributorName: selected ? selected.value : ''
			})
			if (res.code !== 200) return this.$message.error(res.msg || '绑定失败')
			this.$message.success('绑定成功')
			this.addDistributorId = ''
			await this.loadBoundDistributors(this.currentDistributorStaff.id)
			this.getStaffList()
		},
		async unbindDistributor(row) {
			try {
				await this.$confirm(`确认解绑运营商"${row.distributorName}"吗？`, '提示', {
					type: 'warning'
				})
				const { data: res } = await this.$http.delete(`/mini/operationMiniUser/unbindDistributor/${row.id}`)
				if (res.code !== 200) return this.$message.error(res.msg || '解绑失败')
				this.$message.success('解绑成功')
				await this.loadBoundDistributors(this.currentDistributorStaff.id)
				this.getStaffList()
			} catch (e) {
				if (e !== 'cancel') {
					this.$message.error('解绑失败')
				}
			}
		}
	},
}
</script>

<style>
.search-area {
	margin-bottom: 20px;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266 !important;
}
</style>
